import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMsal } from "@azure/msal-react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import BSEELogo from "assets/images/BSEELogo.png";

// Define advanced training links per user role
const trainingLinks = {
  ADMIN: ["iSpring/The Solution (High Level)/index.html"],
  ShenAdmin: ["/iSpring/Advanced/index.html"],
  ShenREG: ["/iSpring/Advanced/index.html"],
  ShenADV: ["/iSpring/Advanced/index.html"],
};

function PreStartupForm() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  const availableLinks = trainingLinks[selectedRole] || [];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Purpose Section */}
      <MDBox
        p={{ xs: 2, sm: 4 }}
        m={{ xs: 2, sm: 4 }}
        bgColor="rgba(148, 148, 148, 0.07)"
        borderRadius="lg"
        shadow="md"
        sx={{
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(15px)",
        }}
      >
        <MDBox mb={3}>
          <h1 style={{ color: "white", fontSize: "32px" }}>Purpose</h1>
          <h2 style={{ color: "white", fontSize: "20px", fontWeight: "normal" }}>
            Why is a SSLD Management Program Needed?
          </h2>
        </MDBox>

        <Grid container spacing={4} alignItems="center">
          {/* Left Column - Logo */}
          <Grid item xs={12} md={4}>
            <MDBox display="flex" justifyContent="center">
              <img
                src={BSEELogo}
                alt="BSEE Logo"
                style={{ maxWidth: "100%", maxHeight: "280px", objectFit: "contain" }}
              />
            </MDBox>
          </Grid>

          {/* Right Column - Purpose Points */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={2}>
              {[
                "BSEE is becoming increasingly invested in SSLD implementation",
                "They want to know who’s accountable & responsible",
                "They want assurance that Operators are prepared, knowledgeable, and confident",
                "They want to see SSLD documentation, reporting, and metrics",
                "They want assurance that the system is tuned to reliably detect leaks",
              ].map((text, index) => (
                <Grid item xs={12} key={index}>
                  <MDBox
                    bgColor="dark"
                    variant="gradient"
                    borderRadius="md"
                    p={2}
                    color="white"
                    fontSize="18px"
                    fontWeight="500"
                  >
                    {text}
                  </MDBox>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>

      {/* Vetted Section */}
      <MDBox
        p={{ xs: 2, sm: 4 }}
        m={{ xs: 2, sm: 4 }}
        bgColor="rgba(148, 148, 148, 0.07)"
        borderRadius="lg"
        shadow="md"
        sx={{
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(15px)",
        }}
      >
        <MDBox mb={2}>
          <h1 style={{ color: "white", fontSize: "32px" }}>SharpWatch® is Vetted</h1>
        </MDBox>

        <ul
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            color: "white",
            paddingLeft: "20px",
          }}
        >
          <li>
            <strong>SharpWatch® SSLD</strong> has <strong>unique</strong> technical advantages and
            has been independently vetted and <strong>endorsed</strong> by the{" "}
            <strong>BSEE-BAST</strong> group.
          </li>
          <li>
            <strong>SharpWatch® CTNA</strong> and <strong>TTM</strong> modules solve CROC’s problems
            with near ambient and slugging flow regimes.
          </li>
          <li>
            Tesla SSLD management program has been described as a <strong>best practice</strong> by
            BSEE.
          </li>
          <li>
            Tesla SSLD Reports and Key Performance Indicators are used by several GoA Deepwater
            Operators.
          </li>
        </ul>
      </MDBox>
    </DashboardLayout>
  );
}

export default PreStartupForm;
